import * as Sentry from '@sentry/nextjs'

export const errorMiddleware = (err) => {
  Sentry.captureException(err)

  return {
    error: err,
    message: err.response?.data?.message?.length
      ? err.response?.data?.message[0]
      : 'Internal server error',
  }
}
